// Every Forms link goes through these helpers with the viewer's route
// prefix (hooks/useAdminRouteContext), so the pages work under /admin today
// and /admin-track or /admin-employee later.

const query = (params) => {
  const parts = Object.keys(params)
    .filter(
      (k) => params[k] !== undefined && params[k] !== null && params[k] !== ''
    )
    .map((k) => `${k}=${encodeURIComponent(params[k])}`);
  return parts.length ? `?${parts.join('&')}` : '';
};

// `${prefix}/forms?account=12&view=archived&page=2` (empty params left out).
export const formsListPath = (prefix, { account, view, page } = {}) =>
  `${prefix}/forms${query({ account, view, page })}`;

export const formBuilderPath = (prefix, id) => `${prefix}/forms/${id}`;

// `${prefix}/forms/${id}/submissions?entry=45`
export const formSubmissionsPath = (prefix, id, { entry } = {}) =>
  `${prefix}/forms/${id}/submissions${query({ entry })}`;
